// extracted by mini-css-extract-plugin
module.exports = {"title":"bD_f","description":"bD_g","caseStudies":"bD_dc","reviews":"bD_hx","caseStudiesCards":"bD_hy","banner":"bD_l"};